import { useParams } from 'react-router';

/** ``:organizationId`` of the current route; the router only matches digits. */
export function useOrganizationId(): number {
  const { organizationId } = useParams();
  return Number(organizationId);
}
